import React from "react"
import { Controller } from "react-hook-form"
import { PhotographyTypes } from "../../../api/Definitions"
import FormInput from "../../../components/Form/Inputs/FormInput"
import SelectInput from "../../../components/Form/Select/Select"
import ArtPieceSharedDetails from "./SharedDetails"

const ArtPiecePhotography = () => {
  return (
    <div className="container">
      <ArtPieceSharedDetails />
      <div className="row">
        <div className="col-6">
          <FormInput
            name="photography.width"
            validation={{
              pattern: {
                value: /^[1-9]\d*(\.\d+)?$/,
                message: "This field can be only number",
              },
            }}
            label="Width"
          />
        </div>
        <div className="col-6">
          <FormInput
            name="photography.height"
            label="Height"
            validation={{
              pattern: {
                value: /^[1-9]\d*(\.\d+)?$/,
                message: "This field can be only number",
              },
            }}
          />
        </div>
      </div>
      <Controller
        as={SelectInput}
        options={PhotographyTypes}
        name="photography.type"
        label="Type"
        isClearable={true}
      />
      <FormInput name="photography.resolution" label="Resolution" />
      <FormInput
        name="photography.edition"
        label="Edition"
        placeholder="E.g. Limited edition, Author print..."
      />
      <div className="row">
        <div className="col-6">
          <FormInput
            name="photography.number"
            label="Number"
            placeholder="E.g. 1"
            validation={{
              pattern: {
                value: /^[1-9]\d*(\.\d+)?$/,
                message: "This field can be only number",
              },
            }}
          />
        </div>
        <div className="col-6">
          <FormInput
            name="photography.numberOf"
            label="Of"
            placeholder="E.g. 5"
            validation={{
              pattern: {
                value: /^[1-9]\d*(\.\d+)?$/,
                message: "This field can be only number",
              },
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default ArtPiecePhotography
